import { Check, Lock } from "lucide-react";

const RING = {
  done: "bg-emerald-500 text-white border-emerald-500",
  active: "bg-white text-indigo-600 border-indigo-500",
  locked: "bg-slate-100 text-slate-400 border-slate-200",
};

export const StepShell = ({ n, title, hint, state, right, children, testid }) => (
  <section data-testid={testid} data-state={state} className={`relative rounded-2xl border bg-white p-5 transition-[border-color,box-shadow] ${state === "active" ? "border-indigo-200 shadow-[0_8px_30px_-12px_rgba(79,70,229,0.35)]" : "border-slate-200"}`}>
    <div className="flex items-start gap-4">
      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 text-sm font-bold ${RING[state]}`}>
        {state === "done" ? <Check className="h-4 w-4" /> : state === "locked" ? <Lock className="h-3.5 w-3.5" /> : n}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-start justify-between gap-2">
          <div>
            <h3 className="font-display text-lg font-semibold text-slate-900">{title}</h3>
            {hint && <p className="text-sm text-slate-500">{hint}</p>}
          </div>
          {right}
        </div>
        {children && <div className="mt-4">{children}</div>}
      </div>
    </div>
  </section>
);

export const Saved = ({ items }) => (
  <dl className="grid gap-3 text-sm sm:grid-cols-2">
    {items.filter(([, v]) => v).map(([l, v]) => (
      <div key={l} className={String(v).length > 60 ? "sm:col-span-2" : ""}>
        <dt className="text-xs font-semibold uppercase tracking-wider text-slate-400">{l}</dt>
        <dd className="mt-0.5 whitespace-pre-wrap text-slate-800">{v}</dd>
      </div>
    ))}
  </dl>
);
